<template>
	<div class="resource-planning-portfolio-add-to-project">
		<ProjectAutoSuggest
			can-modify
			:excluded-users="userId ? [userId] : []"
			ignore-bookmark-users
			@input="onSelectProject($event)"
		/>
	</div>
</template>

<script setup lang="ts">
import { useElementBackgroundClick, useTranslation } from '@/composables';
import { useMessage } from '@/features/Message';
import { ProjectAutoSuggest } from '@/features/Project';
import {
	type Role,
	useResourcePlanningPortfolioAddToProjectMutation,
	type Project,
	type User,
} from '@/generated/graphql';
import { ref } from 'vue';

export type ResourcePlanningPortfolioAddToProjectProps = {
	name: User['name'] | Role['name'];
	userId?: User['id'];
	roleId?: Role['id'];
};

const props = defineProps<ResourcePlanningPortfolioAddToProjectProps>();
const emit = defineEmits(['close', 'auto-suggest-selected']);

const { mutate, onDone } = useResourcePlanningPortfolioAddToProjectMutation({});
const { t } = useTranslation();
const { addSuccessMessage } = useMessage();

const onClose = () => emit('close');

const onSelectProject = (project: {
	id: Project['id'];
	title: Project['name'];
}) => {
	mutate({
		input: {
			projectId: project.id,
			roleIds: props.roleId ? [props.roleId] : undefined,
			userIds: props.userId ? [props.userId] : undefined,
		},
	});
};

onDone((res) => {
	const project = res.data?.ProjectMembersAdd;

	if (project) {
		addSuccessMessage({
			message: t('resource_planning_portfolio_add_to_project_success', {
				userOrRoleName: props.name,
				projectName: project.name,
			}),
		});
	}
	onClose();
});

useElementBackgroundClick(
	'resource-planning-portfolio-add-to-project',
	ref(true),
	onClose
);
</script>

<style lang="scss">
.resource-planning-portfolio-add-to-project {
	padding: 2rem;
}
</style>
